import type { SnapshotFrom } from 'xstate';

import { feature, useFeature } from '@/app/context';

import { schedulesMachine } from './schedules.machine';

export const useSchedulesRef = () => feature('schedules');
export const useSchedules = <R>(selector: (snapshot: SnapshotFrom<typeof schedulesMachine>) => R) =>
  useFeature('schedules', selector);

export const useSchedulesActions = () => {
  const ref = useSchedulesRef();
  return {
    chooseRoute: (routeId: 'E' | '44') => ref.send({ type: 'schedule.choose-route', routeId }),
    chooseDirection: (directionId: string) => ref.send({ type: 'schedule.choose-direction', directionId }),
    chooseStop: (stopId: string) => ref.send({ type: 'schedule.choose-stop', stopId }),
    refreshArrivals: () => ref.send({ type: 'schedule.refresh-arrivals' }),
  };
};
